module.exports = __webpack_public_path__ + "static/quote-image-da1c840f39432d73b659abd90163d63d.png";